import React, { useContext } from 'react';
import { AuthenticationContext } from '../App.js';
import { getWebClient } from '../helpers/Helpers.js';

export default function Login() {

    document.body.style = 'background: #f8f9fa;';

    const { setAuthenticationToken } = useContext(AuthenticationContext);

    const handleSubmit = (event) => {

        event.preventDefault();

        const emailPassword = document.getElementById('email').value + ':' + document.getElementById('password').value;
        const client = getWebClient();

        client.get(`/api/token/${emailPassword}`)
            .then(function (response) {
                if (response.data.token) {
                    localStorage.setItem("adminAuthenticationToken", response.data.token);
                    setAuthenticationToken(response.data.token);
                    document.body.style = 'background: #ffffff;';
                } else {
                    document.getElementById('email').classList.add("is-invalid");
                    document.getElementById('password').classList.add("is-invalid");
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    return (
        <>

            <div className="container vh-100" id="divFormContainer">
                <div className="row h-100 justify-content-center align-items-center">

                    <div className="col-12 col-md-11 col-lg-8 col-xl-7 col-xxl-6">
                        <div className="bg-white p-4 p-md-5 rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <div className="text-center mb-5">
                                        <h1 className="h4">SIHE workshop - area amministrativa</h1>
                                    </div>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="row gy-3 gy-md-4 overflow-hidden">
                                    <div className="col-12">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="text" className="form-control" id="email" />
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input type="password"className="form-control"id="password"/>
                                    </div>

                                    <div className="col-12">
                                        <div className="d-grid">
                                            <button className="btn btn-primary btn-lg" type="submit">
                                                Log in
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="row">
                                <div className="col-12">
                                    <hr className="mt-5 mb-4 border-secondary-subtle" />
                                    <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center">
                                        SIHE - Swiss International Holiday Exhibition
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}
